module.exports = __webpack_public_path__ + "img/warehouse.898957af.gif";